<a [routerLink]="[link]" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: exact }" [title]="title">
  <div class="circle">
    <img *ngIf="iconPath" src="{{ iconPath }}" alt="{{ title }}" />
  </div>
  <span class="d-none d-lg-inline-block">{{ title }}</span>
</a>
